import DefaultLayout from '../../../layout/DefautlLayout';
import Header from '../../../components/header/Header';
import { Link } from 'react-router-dom';
import TreatmentIntroBanner from '../../../components/treatmentBanner/treatmentBanner';

const SkinConsultationPage = () => {
	const prices = [{ label: 'Consultation', value: 'Free' }];

	return (
		<DefaultLayout>
			<Header />
			<div id="Content">
				<div className="content_wrapper clearfix">
					<div className="sections_group">
						<div className="extra_content">
							<TreatmentIntroBanner
								title="Skin Consultation"
								description="A complimentary, doctor-led consultation that evaluates your skin's needs and matches you with advanced, safe aesthetic treatments—offering personalised guidance and a plan for long-term skin health."
								quote=" Every great skincare journey begins with a clear understanding of you. "
								backgroundImage="/assets/images/banners/treatment-xl-2.png"
							/>

							<div className="section mcb-section" style={{ paddingBottom: '70px' }}>
								<div className="section_wrapper mcb-section-inner">
									<div className="wrap mcb-wrap one valign-top clearfix">
										<div className="mcb-wrap-inner">
											<div className="column mcb-column one-third column_image">
												<div className="image_frame image_item scale-with-grid aligncenter has_border hrmargin_b_30">
													<div className="image_wrapper">
														<div className="mask"></div>
														<img
															className="scale-with-grid"
															src="/assets/images/treatments/skin-consultation.jpg"
															alt="Skin Consultation"
															width="960"
															height="960"
														/>
													</div>
												</div>
											</div>

											<div className="column mcb-column two-third column_column">
												<div className="column_attr clearfix">
													<h4>What's Included</h4>
													<ul>
														<li>Thorough skin analysis by a qualified doctor.</li>
														<li>Identify skin concerns and recommend tailored treatment options.</li>
														<li>Explore advanced treatments like PRP, Profhilo, skin boosters, lasers, polynucleotides, etc.</li>
													</ul>

													<h4>Why It Matters</h4>
													<p>
														Our complimentary consultation ensures every treatment plan is safe, targeted, and aligned with your
														skin goals—supported by expert clinical advice and access to our full range of advanced therapies.
													</p>

													<h4>Next Steps</h4>
													<p>
														Following your assessment, you'll receive a personalised treatment plan, pricing, and timeline to help
														you achieve long-lasting, healthy skin.
													</p>
												</div>
											</div>

											<div className="column mcb-column one column_column">
												<div className="column_attr clearfix">
													<div className="column one column_pricing_item">
														<div className="pricing-box custom-pricing-box pricing-box-table pricing-box-featured">
															<div className="plan-header">
																<h3>Pricing</h3>
															</div>
															<div className="plan-inside clearfix">
																<hr className="bg-theme" />
																<ul>
																	{prices.map(({ label, value }, idx) => (
																		<li key={idx} className="clearfix" style={{ paddingLeft: '5%', paddingRight: '5%' }}>
																			<div>
																				<strong>{label}</strong>
																			</div>
																			<div style={{ whiteSpace: 'pre-line' }}>{value}</div>
																		</li>
																	))}
																</ul>
																<hr className="bg-theme" />
															</div>
															<div className="plan-footer">
																<Link to="/book-now" className="button button_left button_theme button_js">
																	<span className="button_icon">
																		<i className="icon-basket"></i>
																	</span>
																	<span className="button_label">BOOK NOW</span>
																</Link>
															</div>
														</div>
													</div>
												</div>
											</div>

											<div className="column mcb-column one column_divider">
												<hr className="no_line" />
											</div>

											<div className="column one column_slider">
												<div className="column_attr clearfix hrmargin_b_60">
													<h2 className="hrmargin_b_60" style={{ textAlign: 'center' }}>
														Results
													</h2>
													<div className="content_slider">
														<ul className="content_slider_ul">
															<li className="content_slider_li_1">
																<img
																	width="100%"
																	height="auto"
																	src="/assets/images/treatments/skin-consultation-result.jpg"
																	alt="Consultation Outcome"
																	className="scale-with-grid wp-post-image"
																/>
															</li>
														</ul>
													</div>
												</div>
											</div>

											<div className="column mcb-column one column_divider">
												<hr className="no_line" />
											</div>

											<div className="column mcb-column one column_column">
												<div className="column_attr clearfix">
													<h2 className="hrmargin_b_60" style={{ textAlign: 'center' }}>
														After-Care
													</h2>
													<ul>
														<li>
															Receive bespoke after-care advice and recommended products tailored to your skin type, lifestyle,
															and long-term goals for optimal results.
														</li>
														<li>
															Access follow-up appointments or complimentary check-ins to monitor progress, make adjustments, and
															ensure satisfaction with your treatment outcome.
														</li>
														<li>
															Gain full clarity on your treatment plan and timeline, including next steps, suitable intervals, and
															supporting skincare routines or boosters.
														</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</DefaultLayout>
	);
};

export default SkinConsultationPage;
